import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import PubSub from 'pubsub-js'
import { SET_AREA_STATES_MUTATION } from '../../graphql.js'
import { USER_AREAS_QUERY } from '../../graphql.js'
import Area from '../Area/Area'
import './AreaSidebar.css'
import { Alert } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils.js'

export const SET_AREA_STATES = gql(SET_AREA_STATES_MUTATION)
export const USER_AREAS = gql(USER_AREAS_QUERY)

export default function AreaSidebar() {
  console.log('AreaSidebar rendered')

  const [className, setClassName] = useState('sidebar-not-collapsed')
  const [areas, setAreas] = useState([])
  const [areaStates, setAreaStates] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    let mounted = true
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: USER_AREAS })
        if (data.userAreas && mounted) {
          //console.log('AreaSidebar areaStates: ', data.userAreas.areaStates)
          setAreaStates(data.userAreas.areaStates)
          setAreas(data.userAreas.areas)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
    return (() => mounted = false)
  }, [])

  useEffect(() => {
    function handleSidebarEvent(msg, data) {
      console.log(`EVENT RECEIVED (AreaSidebar): ${msg}`, data)

      let newClassName = null
      if (data && data.className) {
        // Event data contains specific sidebar state
        newClassName = data.className
      } else {
        // Toggle the sidebar state
        if (className === 'sidebar-not-collapsed') {
          newClassName = 'sidebar-collapsed'
        } else {
          newClassName = 'sidebar-not-collapsed'
        }
      }
      setClassName(newClassName)
    }

    async function handleAreaEvent(msg, area) {
      console.log(`EVENT RECEIVED (AreaSidebar): ${msg}`, area)
      console.log(areaStates)
      const newAreaStates = []
      for (let areaState of areaStates) {
        let newState = areaState.id === area.id ? area.state : areaState.state
        newAreaStates.push({ id: areaState.id, state: newState })
      }
      setAreaStates(newAreaStates)
      await window.apolloClient.mutate({ mutation: SET_AREA_STATES, variables: { areaStates: newAreaStates } })
    }

    const token1 = PubSub.subscribe('SIDEBAR', handleSidebarEvent)
    const token2 = PubSub.subscribe('SIDEBAR AREA CHANGED', handleAreaEvent)
    return function cleanup() {
      PubSub.unsubscribe(token1)
      PubSub.unsubscribe(token2)
    }
  })

  // create an object of the shape {1111: "open", 2222: "closed",...}
  // so we can use the area ID as an index into the object to get the area state (open or closed)
  const statesObject = {}
  for (let statePair of areaStates) {
    statesObject[statePair.id] = statePair.state
  }

  const areaGroups = []
  if (areas) {
    for (let area of areas) {
      areaGroups.push(<Area key={area.id} area={area} initialCollapseState={statesObject[area.id]} />)
    }
  }

  // Set the body padding based on the AreaSidebar state
  if (className === 'sidebar-collapsed') {
    document.body.classList.remove('side-bar-padding')
  } else {
    document.body.classList.add('side-bar-padding')
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else {
    return (
      <div className={className} data-cy={className}>
        {areaGroups}
      </div>
    )
  }
}
